// Si vous souhaitez recharger, supprimez-le et c'est OK.
// Vanilla
let cptUpdate = 0;


const anchors = document.querySelectorAll('a');
anchors.forEach(anchor => {
    anchor.setAttribute('data-barba-prevent', '');
});

document.addEventListener("DOMContentLoaded", function () {

    setTimeout(function () {
        // $("#panel3").addClass("is-loaded");
        const tl = gsap.timeline();
        tl.to('#panel3 .logo img', {
            duration: 1,
            opacity: 0.8,
            ease: Power3.easeInOut,
            delay: -0.1
        });
        tl.to('#panel3 .logo img', {
            duration: .5,
            opacity: 0,
            ease: Power2.easeInOut
        });
        tl.to('#panel3', {
            duration: .7,
            opacity: 0,
            ease: Power1.easeInOut,
            delay: -0.1
        });

    }, 1200);
    //FIN DOCUMENT.READY

    // SET DATA PREVENT ATTRIBUTE TO SELECTED LINKS
    let noBarbaPage = [];
    // console.log(noBarbaPage);
    let housePage = document.querySelector('.the-house-link a') ? noBarbaPage.push(document.querySelector('.the-house-link a')) : null;
    let regionLink = document.querySelector('.the-region-link a') ? noBarbaPage.push(document.querySelector('.the-region-link a')) : null;
    let langItem = document.querySelector('.lang-item a') ? noBarbaPage.push(document.querySelector('.lang-item a')) : null;

    noBarbaPage = noBarbaPage.concat(Array.from(document.querySelectorAll('.barba-prevent a')));
    if (noBarbaPage.length != 0) {
        noBarbaPage.forEach(function (thisElement) {
            if (thisElement) thisElement.setAttribute('data-barba-prevent', '');
        });
    }

    var links = document.querySelectorAll('a[href]');
    var cbk = function (e) {
        if (e.currentTarget.href === window.location.href) {
            //IF WE ARE ALREADY ON THE PAGE
            // DO NOTHING
            e.preventDefault();
            e.stopPropagation();
        }
    };
    for (var i = 0; i < links.length; i++) {
        links[i].addEventListener('click', cbk);
    }

    var animComplete = 0;
    // init Barba
    // console.log('BARBA INIT');

    window.onbeforeunload = function () {
        window.scrollTo(0, 0);
    };

    barba.hooks.beforeEnter(({
        current,
        next
    }) => {
        // Set <body> classes for the 'next' page
        if (current.container) {
            // // only run during a page transition - not initial load
            let nextHtml = next.html;
            let response = nextHtml.replace(
                /(<\/?)body( .+?)?>/gi,
                "$1notbody$2>",
                nextHtml
            );
            let bodyClasses = $(response).filter("notbody").attr("class");
            $("body").attr("class", bodyClasses);
        }
    });



    barba.init({
        // debug: true,
        timeout: 6000,
        sync: true,

        transitions: [{
            name: 'default-transition',
            beforeOnce() {},
            once() {

                // QUAND LA PAGE EST ENTIEREMENT RECHARGEE


                // console.log('once');
                loadingFunctionOnPageInit();
                mapHome();
                setFlatPickr();
                // formatCookie();
                window.addEventListener('mousemove', enableMenuHover)

                document.querySelectorAll('.arrow-footer')
                    .forEach(el => {
                        el.addEventListener('click', (e) => {
                            // console.log(el);
                            e.preventDefault();
                            scroll.scrollTo(0, 0);
                        })
                    })

                cptUpdate = 0;
                let updateLoop = setInterval(() => {
                    cptUpdate++;
                    scroll.update();
                    console.log('update');
                    if (cptUpdate === 5) {
                        clearInterval(updateLoop)
                    }

                }, 4000);


                setTimeout(function () {
                    document.documentElement.classList.remove("addDelayOnHeaderAnimations");
                }, 6000);
                //updateScrollInterval();

            },
            leave() {
                // create your stunning leave animation here
                // console.log('leave page');
                const tl = gsap.timeline();
                tl.to('#panel3', {
                    duration: .4,
                    opacity: 1,
                    ease: Power1.easeInOut
                });


                // PERMET DE RENDRE LA TRANSITION ASYNCHRONE CHARGEMENT PENDANT QUE LA TRANSITION SE FAIT
                const done = this.async();


                document.documentElement.classList.add("addDelayOnHeaderAnimations");
                // animTransition.playSegments([0, 16], false);
                setTimeout(function () {

                    //                    scroll.scrollTo(0, 10, 10, [0.00, 0.28, 0.00, 1.00], true);


                    // SCROLL TO FUNCTION - LOCOMOTIVE
                    // ---------- Scroll en haut de page très rapidement
                    //  scroll.scrollTo(0,{duration:10, easing:[1, 0, 0, 1]});
                    // ---------- scroll To mon id selectionnée dans l'url
                    // scroll.scrollTo(document.querySelector(window.location.hash),{duration:1000, easeing:[1, 0, 0, 1]});

                    scroll.scrollTo(0, {
                        duration: 10,
                        easing: [1, 0, 0, 1]
                    });


                }, 500);
                setTimeout(function () {
                    done();
                    //scrollTo(target, offset, duration, easing, disableLerp, callback(function))
                    // animTransition.playSegments([16,63], true);
                }, 1000);


                // FADE OUT ALL CONTENT
                //                gsap.to(data.current.container, {
                //                    duration: 1,
                //                    opacity: 0,
                //                });

            },
            enter() {
                //create your amazing enter animation here
                const tl = gsap.timeline();
                tl.to('#panel3 .logo img', {
                    duration: 1,
                    opacity: 0.8,
                    ease: Power3.easeInOut,
                    delay: -0.1
                });
                tl.to('#panel3 .logo img', {
                    duration: .5,
                    opacity: 0,
                    ease: Power2.easeInOut
                });
                tl.to('#panel3', {
                    duration: .7,
                    opacity: 0,
                    ease: Power1.easeInOut,
                    delay: -0.1
                });
                // console.log('enter in page');
                scroll.update();
                document.querySelectorAll('.arrow-footer')
                    .forEach(el => {
                        el.addEventListener('click', (e) => {
                            // console.log(el);
                            e.preventDefault();
                            scroll.scrollTo(0, 0);
                        })
                    })
                setFlatPickr();
                loadVideos();
                // formatCookie();
                window.addEventListener('mousemove', enableMenuHover)




                // REACTIVATE BELOW IF PB ON FUNCITON PAGE LOAD
                //loadingFunctionOnPageInit();
            },
            after() {
                scroll.update();

                // animTransition.playSegments([16, 63], true);
                // document.getElementById("panel3").classList.add("is-loaded");
                // console.log('after');
                document.querySelectorAll('.arrow-footer')
                    .forEach(el => {
                        el.addEventListener('click', (e) => {
                            // console.log(el);
                            e.preventDefault();
                            scroll.scrollTo(0, 0);
                        })
                    })
                loadingFunctionOnPageInit();
                mapHome(); // prevent conflict between 2 maps
                checkMenuIsClosed();
                setFlatPickr();
                // formatCookie();
                window.addEventListener('mousemove', enableMenuHover)

                // QUAND LA PAGE EST ENTIEREMENT RECHARGEE

                setTimeout(function () {
                    document.documentElement.classList.remove("addDelayOnHeaderAnimations");
                }, 6000);
            }
        }]
    });


});

// // PERMET DE GERER LES CONTACT FORM 7 EN AJAX
// function initContactForm() {
//     $('div.wpcf7 > form').each(function () {
//         var $form = $(this);
//         wpcf7.initForm($form);
//         if (wpcf7.cached) {
//             wpcf7.refill($form);
// console.log('funciton initContactForm()');
//         }
//     });
// }

function loadingFunctionOnPageInit() {
    // console.log('loadingFunctionOnPageInit()');
    // TO REACTIVATE TIMEOUT IF AFTER AJAX PAGE PB ON FUNCTION EXECUTION
    //    setTimeout(() => {
    initParts();
    //    }, 250);

    setTimeout(() => {
        // console.log('SMOOTH UPDATE 2');
        scroll.update();
    }, 3000);
}




function setBooking() {
    Date.prototype.toDateInputValue = (function () {
        var local = new Date(this);
        local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
        return local.toJSON().slice(0, 10);
    });

    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    document.getElementById('date_arr').value = new Date().toDateInputValue();
    document.getElementById('date_arr').setAttribute('min', new Date().toDateInputValue());
    document.getElementById('date_dep').value = tomorrow.toDateInputValue();
    document.getElementById('date_dep').setAttribute('min', tomorrow.toDateInputValue());


    document.getElementById('date_arr').addEventListener('change', (e) => {
        let arrDate = new Date(document.getElementById('date_arr').value);
        let depDate = new Date(document.getElementById('date_dep').value);

        if (arrDate >= depDate) {
            arrDate.setDate(arrDate.getDate() + 1);
            document.getElementById('date_dep').value = arrDate.toDateInputValue();
        }
    })

    document.getElementById('date_dep').addEventListener('change', (e) => {
        let arrDate = new Date(document.getElementById('date_arr').value);
        let depDate = new Date(document.getElementById('date_dep').value);

        // console.log(arrDate >= depDate);

        if (arrDate >= depDate) {
            // console.log(depDate);
            depDate.setDate(depDate.getDate() - 1);
            document.getElementById('date_arr').value = depDate.toDateInputValue();
        }
    })


    document.getElementById('form_reservation').addEventListener('click', function (e) {
        e.preventDefault();
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        };

        let methode = "recherche",
            dateArr = new Date(document.getElementById('date_arr').value).toLocaleDateString('fr-FR', options),
            dateDep = new Date(document.getElementById('date_dep').value).toLocaleDateString('fr-FR', options),
            nbChambre = 1,
            nbPersonne = document.getElementById('nb_personne').value

        let currentLanguage;

        if (document.documentElement.lang === "fr-FR") {
            currentLanguage = "fr";
        } else {
            currentLanguage = "us";
        }



        window.open(`https://hotel-le-cornouaille-benodet.galaxy-reservation.fr/_actions/RechercheAction.php?methode=${methode}&date_arr=${dateArr}&date_dep=${dateDep}&nombre_chambre=${nbChambre}&nb_personne=${nbPersonne}&langue=${currentLanguage}`, '_blank')
    })
}


function enableMenuHover({
    clientY
}) {
    if (clientY <= 80) {
        document.querySelector('header.main-header').classList.remove('is-hidden');
    }
}





function setFlatPickr() {
    flatpickr.localize(flatpickr.l10ns.ru);
    const today = new Date();
    const todayString = `${today.getFullYear()}-${today.getMonth() + 1 }-${today.getDate()}`
    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowString = `${tomorrow.getFullYear()}-${tomorrow.getMonth() + 1 }-${tomorrow.getDate()}`
    let dateArrInput;
    let dateDepInput;




    dateArrInput = flatpickr("#date_arr", {
        defaultDate: todayString,
        onChange: (selectedDates, DateStr, instance) => {
            if (dateDepInput.selectedDates[0] <= selectedDates[0]) {
                let followingDay = new Date();
                followingDay.setDate(selectedDates[0].getDate() + 1);
                dateDepInput.setDate(followingDay);
            }
        }
    });
    dateDepInput = flatpickr("#date_dep", {
        defaultDate: tomorrowString,
        onChange: (selectedDates, DateStr, instance) => {
            if (dateArrInput.selectedDates[0] >= selectedDates[0]) {
                // console.log(dateArrInput.selectedDates[0] );
                // console.log(selectedDates[0]);
                let previousDay = new Date();
                previousDay.setDate(selectedDates[0].getDate() - 1);
                dateArrInput.setDate(previousDay);
            }
        }
    });


    document.getElementById('form_reservation').addEventListener('click', function (e) {
        e.preventDefault();
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        };

        let methode = "recherche",
            dateArr = new Date(document.getElementById('date_arr').value).toLocaleDateString('fr-FR', options),
            dateDep = new Date(document.getElementById('date_dep').value).toLocaleDateString('fr-FR', options),
            nbChambre = 1,
            nbPersonne = document.getElementById('nb_personne').value

        let currentLanguage;

        if (document.documentElement.lang === "fr-FR") {
            currentLanguage = "fr";
        } else {
            currentLanguage = "us";
        }

        window.open(`https://hotel-le-cornouaille-benodet.galaxy-reservation.fr/_actions/RechercheAction.php?methode=${methode}&date_arr=${dateArr}&date_dep=${dateDep}&nombre_chambre=${nbChambre}&nb_personne=${nbPersonne}&langue=${currentLanguage}`, '_blank')
    })

}

// function formatCookie() {
//     let cookieButtons = document.getElementById('cn-notice-buttons')
//     let childrens = cookieButtons.childNodes
//     let element = childrens[0].cloneNode(true);
//     childrens[0].remove()
//     cookieButtons.insertAdjacentElement('beforeend', element)
// }
